$(function(){

  onloadAppendWidget();
});

openYtbPopup = (evt) =>{
  var _this = $(evt);
  var get_src = $('#_ytbsection').attr('data-src');
  $('#ytbPopup').show();
  $('.js-focus-visible').css('overflow','hidden');
  $('.jsc-ytb-iframe').attr('src',get_src);
  // console.log($('.shg-fw'),'get_src');
}

closeYtbPop = () =>{
  $('#ytbPopup').hide();
  $('.js-focus-visible').css('overflow','auto');
  $('.jsc-ytb-iframe').attr('src','');
   // console.log('close');
}

onloadAppendWidget = () =>{

  var $eleContainer = $('.jsc-get-review-widget');
  var $eleChild = $eleContainer.children();
  var $appendContainer = $('.shogun-root .shg-box-vertical-align-wrapper > .shg-box:visible .jsc-append-widget');

  //remove actual widget element on shopify template
  $eleContainer.remove();

  // append widget to shogun page
  $appendContainer.append($eleChild);
}
